module.exports = __webpack_public_path__ + "img/logo-intelite.89a9710a.png";